module.exports = __webpack_public_path__ + "static/0059-7d2d48980d0149f4521e42429d477017.png";